<template>
	<div style="width: 100%; ">
		<div class="hometop">
			<el-row>
				<el-col :span="24" class="title">
					{{$t('calendar.calendar_lbl0')}}
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="titleSmall">
					{{$t('calendar.calendar_lbl1')}}
				</el-col>
			</el-row>

		</div>


            <div class="homecalend">
                <div class="custom-calendar">
                    <div class="calendar-header">
                        <button class="nav-btn" @click="prevMonth">&lt;</button>
                        <div class="month-year">{{ currentYear }} / {{ currentMonth + 1 }}</div>
                        <button class="nav-btn" @click="nextMonth">&gt;</button>
                    </div>
                    
                    <div class="calendar-weekdays">
                        <div v-for="(day, index) in weekDays" 
                             :key="day" 
                             :class="{'weekday-sunday': index === 0}">
                            {{ day }}
                        </div>
                    </div>
                    
                    <div class="calendar-days">
                        <div 
                            v-for="(day, index) in calendarDays" 
                            :key="index" 
                            :class="[
                                'day', 
                                { 'disabled': day.disabled }, 
                                { 'current-day': day.isToday }, 
                                { 'rest-day': day.isRestDay },
                                { 'selected': day.isSelected },
                                { 'sunday': day.isSunday }
                            ]"
                            @click="selectDate(day)"
							
                        >
						
                            <div class="day-number">{{ day.date }}</div>
                        </div>
                    </div>
                    
                </div>
            </div>

	</div>
</template>

<script>
	export default {
            data() {
                return {
					
						value: new Date(),
						height: '70px',
						start: Number(7),
						collectList: [],
						calen: 1,
						mdhid: '',
						MCCTIME: [],
						weeks:['0', '1', '2', '3', '4', '5', '6'],
						
                    currentDate: new Date(),
                    selectedDate: null,
                    weekDays: ['日', '一', '二', '三', '四', '五', '六'],
                    // 模拟休息日数据（实际应用中可以从后端获取）selectDate
                    restDays: [],
                    // 模拟多语言，实际应用中应该使用vue-i18n
                    $t: function(key) {
                        const translations = {
                            'calendar.calendar_lbl0': '工作日历',
                            'calendar.calendar_lbl1': '查看和安排您的工作与休息日'
                        };
                        return translations[key] || key;
                    }
                };
            },
            computed: {
                currentYear() {
                    return this.currentDate.getFullYear();
                },
                currentMonth() {
                    return this.currentDate.getMonth();
                },
                todayDate() {
                    const today = new Date();
                    return `${today.getFullYear()}年${today.getMonth() + 1}月${today.getDate()}日`;
                },
                calendarDays() {
                    const year = this.currentYear;
                    const month = this.currentMonth;
                    
                    // 获取本月第一天和最后一天
                    const firstDay = new Date(year, month, 1);
                    const lastDay = new Date(year, month + 1, 0);
                    
                    // 计算本月第一天是星期几（0是星期日）
                    const firstDayIndex = firstDay.getDay();
                    
                    // 计算本月总天数
                    const daysInMonth = lastDay.getDate();
                    
                    // 计算需要显示的上月剩余天数
                    const prevMonthLastDay = new Date(year, month, 0).getDate();
                    
                    const days = [];
                    const today = new Date();
                    
                    // 添加上月的日期
                    for (let i = firstDayIndex; i > 0; i--) {
                        const date = prevMonthLastDay - i + 1;
                        const prevMonthDate = new Date(year, month - 1, date);
                        days.push({
                            date: date,
                            disabled: true,
                            isToday: false,
                            isRestDay: false,
                            isSelected: false,
                            isSunday: prevMonthDate.getDay() === 0,
                            weekDay: this.weekDays[prevMonthDate.getDay()],
                            fullDate: prevMonthDate
                        });
                    }
                    
                    // 添加本月的日期
   for (let i = 1; i <= daysInMonth; i++) {
            const dateString = this.formatDate(year, month, i);
            const cellDate = new Date(year, month, i);
            const isPastDate = cellDate < new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const isSunday = cellDate.getDay() === 0;
            
            // 修改休息日判断逻辑
            const isRestDay = this.restDays.some(restDay => restDay.TKBMSTDT === dateString);
            
            // 休息日或过去日期都不可点击
            const disabled = isPastDate || isRestDay;
            
            days.push({
                date: i,
                disabled: disabled, // 休息日也设置为不可点击
                isToday: year === today.getFullYear() && 
                        month === today.getMonth() && 
                        i === today.getDate(),
                isRestDay: isRestDay,
                isSelected: this.selectedDate && 
                           year === this.selectedDate.getFullYear() && 
                           month === this.selectedDate.getMonth() && 
                           i === this.selectedDate.getDate(),
                isSunday: isSunday,
                weekDay: this.weekDays[cellDate.getDay()],
                fullDate: cellDate
            });
        }
                    
                    // 计算需要显示的下月天数
                    const totalCells = 42; // 6行7列
                    const nextDaysCount = totalCells - (firstDayIndex + daysInMonth);
                    
                    // 添加下月的日期
                    for (let i = 1; i <= nextDaysCount; i++) {
                        const nextMonthDate = new Date(year, month + 1, i);
                        days.push({
                            date: i,
                            disabled: true,
                            isToday: false,
                            isRestDay: false,
                            isSelected: false,
                            isSunday: nextMonthDate.getDay() === 0,
                            weekDay: this.weekDays[nextMonthDate.getDay()],
                            fullDate: nextMonthDate
                        });
                    }
                    
                    		const start = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
                    		const end = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
                            
                            console.log('当前月份第一天:', start.toLocaleDateString());
                            console.log('当前月份最后一天:', end.toLocaleDateString());
                    
                    			        // 加载下个月的休息日
                    			        this.getCollect(start, end);
                    return days;
                }
            },
            methods: {
				
					fillZero(val) {
						let newVAL = '';
						if (val.toString().length < 2) {
							newVAL = "0" + val.toString();
						} else {
							newVAL = val.toString();
						}
						return newVAL;
					},
                prevMonth() {
                    this.currentDate = new Date(
                        this.currentDate.getFullYear(),
                        this.currentDate.getMonth() - 1,
1
                    );
							const start = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
							const end = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
        
					        console.log('当前月份第一天:', start.toLocaleDateString());
					        console.log('当前月份最后一天:', end.toLocaleDateString());

								        // 加载下个月的休息日
								        this.getCollect(start, end);
					
                },
                nextMonth() {
					// 获取当前显示的第一个日期和最后一个日期
					        
					        
					        // 切换到下个月
					        this.currentDate = new Date(
					            this.currentDate.getFullYear(),
					            this.currentDate.getMonth() + 1,
					            1
								   );
							const start = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
							const end = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
        
					        console.log('当前月份第一天:', start.toLocaleDateString());
					        console.log('当前月份最后一天:', end.toLocaleDateString());

								        // 加载下个月的休息日
								        this.getCollect(start, end);
					
                  
                },
                selectDate(day) {
					
					// 休息日或禁用日期不可点击
					if (day.disabled) return;
                    if (day.disabled) return;
                    
                    this.selectedDate = day.fullDate;
                    console.log('选中日期:', this.selectedDate.toLocaleDateString());
                    
                    // 发送数据到后台
                    this.allcalendar(day);
                },
                formatDate(year, month, day) {
                    return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                },
                sendDateToServer(day) {
                    // 模拟发送数据到后台
                    const dateStr = this.formatDate(
                        day.fullDate.getFullYear(),
                        day.fullDate.getMonth(),
                        day.fullDate.getDate()
                    );
                    
                    const dataToSend = {
                        date: dateStr,
                        weekDay: day.weekDay
                    };
                    
                    console.log('发送到后台的数据:', dataToSend);
                    alert(`发送到后台: ${dateStr} ${day.weekDay}`);
                    
                    // 实际应用中可以使用axios或fetch发送数据
                    /*
                    axios.post('/api/save-date', dataToSend)
                        .then(response => {
                            console.log('数据发送成功', response);
                        })
                        .catch(error => {
                            console.error('数据发送失败', error);
                        });
                    */
                },
				allcalendar(val) {
					this.calen = 1;
					let year = new Date().getFullYear();
					let month = this.fillZero((this.currentDate.getMonth() + 1))
					let day = this.fillZero(this.currentDate.getDate());
					this.selectedDate = day.fullDate;
					let datetime = year + '-' + month + '-' + day
					let years = val.fullDate.getFullYear()
					let months = this.fillZero(val.fullDate.getMonth() + 1)
					let days = this.fillZero(val.fullDate.getDate())
					let datetimes = years + '-' + months + '-' + days
					if (datetime > datetimes) {
						this.$message({
							message: this.$t('calendar.calendar_lbl5'), //当前日为休息日
							type: 'warning'
						});
				
						return;
					} else {
				
						let timelist = this.restDays.filter(item => item.TKBMSTDT == datetimes);
				
						if (timelist.length > 0) {
							this.$message({
								message: this.$t('calendar.calendar_lbl4'), //当前日为休息日
								type: 'warning'
							});
							this.calen = 0
							return;
						}
						if (this.MCCTIME.length == 0){
							alert(this.$t('calendar.calendar_lbl6'));
							return;
						} else {
						let closeTIME = this.MCCTIME[0].MCCOPNTM.split('～')[1].replace("：", ":") //闭店的
						
						let curDATE = new Date();
						let year = curDATE.getFullYear();
				
						let month = this.fillZero((curDATE.getMonth() + 1));
				
						let day = this.fillZero(curDATE.getDate());
						let curHOURS = this.fillZero(curDATE.getHours());
						let curmins = this.fillZero(curDATE.getMinutes());
				
					    let weekday = this.weeks[new Date().getDay()];
				
						let newtime = year + "-" + month + "-" + day;
						let newHM = curHOURS + ":" + curmins;
				            console.log(newtime)
				            console.log(datetimes)
						if (newtime == datetimes) //等于当前日期
						{
							if (newHM > closeTIME) // 判断是否闭店了
							{
				
								this.$message({
									message: this.$t('calendar.calendar_lbl5'), //当前日为休息日
									type: 'warning'
								});
				
								return;
							}
				
						}
				
						if (this.calen == 1) {
							console.log('ss')
				
							console.log(this.$route.query.carid)
				            console.log(weekday)
							if (typeof(this.mdhid) != "undefined" && this.mdhid != "") {
								this.$router.push({
									path: '/CarLineDetail',
									query: {
										curTime: datetimes,
										carid: this.mdhid,
										weekday:weekday
										// timedata:timedata
									}
								})
				
				
							} else {
								console.log(weekday)
								this.$router.push({
									path: '/CarLine',
									query: {
										curDate: datetimes,
										// timedata:timedata
										weekday:weekday
									}
								})
							}
				
						}
						}
						}
				},
				
				
				getCollect(start, end) {
				
					this.$api.post(this.$config.Get_TKB, {
							'sSTART': start,
							'sEND': end
						},
						// 请求成功
						success => {
							console.log(success)
							// console.log("_________我的收藏success")
							console.log(success)
							this.MCCTIME = success.KKDT1;
							console.log(this.MCCTIME)
							let count = parseInt(success.KKDTCOUNT0)
							if (count != 0) {
								this.restDays = success.KKDT0;
							console.log(this.restDays)
				
							} else {
								this.restDays = []
							}
						},
						// 请求失败
						error => {
							console.log(error)
							alert(this.$t('calendar.calendar_lbl6'));
						}
					)
				},
				 // 模拟加载休息日数据
				    simulateLoadRestDays(year, month) {
				        // 模拟API延迟
				        setTimeout(() => {
				            // 根据月份生成不同的休息日数据
				            const nextMonth = month + 1;
				            const nextYear = nextMonth > 11 ? year + 1 : year;
				            const adjustedMonth = nextMonth > 11 ? 0 : nextMonth;
				            
				            // 生成下个月的休息日（模拟数据）- 使用新的数据结构
				            const newRestDays = [];
				            const daysInMonth = new Date(nextYear, adjustedMonth + 1, 0).getDate();
				            
				            // 添加周末作为休息日
				            for (let i = 1; i <= daysInMonth; i++) {
				                const date = new Date(nextYear, adjustedMonth, i);
				                if (date.getDay() === 0 || date.getDay() === 6) { // 周六和周日
				                    newRestDays.push({ 
				                        TKBMSTDT: this.formatDate(nextYear, adjustedMonth, i)
				                    });
				                }
				            }
				            
				            // 添加一些额外的休息日（模拟特殊节假日）
				            if (adjustedMonth === 11) { // 12月
				                newRestDays.push({ TKBMSTDT: `${nextYear}-12-25` }); // 圣诞节
				            } else if (adjustedMonth === 0) { // 1月
				                newRestDays.push({ TKBMSTDT: `${nextYear}-01-01` }); // 元旦
				            }
				            
				            // 移除当前月份的旧休息日数据
				            this.restDays = this.restDays.filter(day => {
				                const dayDate = new Date(day.TKBMSTDT);
				                return dayDate.getMonth() !== adjustedMonth || dayDate.getFullYear() !== nextYear;
				            });
				            
				            // 添加新的休息日数据
				            this.restDays = this.restDays.concat(newRestDays);
				            
				            console.log('更新后的休息日数据:', this.restDays);
				            
				            // 刷新日历显示
				            this.$forceUpdate();
				        }, 300); // 模拟网络延迟
				    },
            },
			
			created() {
			
				sessionStorage.setItem("orderForm", '')
				sessionStorage.setItem("carform", '')
				let type = this.$route.query.type;
			
				this.mdhid = this.$route.query.carid;
			
				if (type == "Login" && (sessionStorage.getItem('log_mstid') == null || sessionStorage.getItem('log_mstid') ==
						"")) {
					this.$parent.$refs["headview"].dialogResetVisible = false;
					this.$parent.$refs["headview"].dialogLoginVisible = true;
			
					this.$parent.$refs["headview"].dialogRegisterVisible = false;
				}
			},
            mounted() {
                
                			let daysinfo = document.getElementsByClassName("days");
                			let start = daysinfo[0].innerHTML;
                			let end = daysinfo[daysinfo.length - 1].innerHTML;
            }
			}
</script>

<style scoped>
			
		* {
			margin: 0;
			padding: 0;
			box-sizing: border-box;
			font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
		}

		body {
			background-color: #f5f7fa;
			padding: 20px;
			color: #333;
		}

		.titleSmall {
			font-size: 12px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			font-weight: bold;
			color: #000000;
		}

		.container {
			max-width: 1000px;
			margin: 0 auto;
			background: white;
			border-radius: 8px;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
			overflow: hidden;
		}

		.custom-calendar {
			background: white;
			border-radius: 6px;
			padding: 15px;
			border: 2px solid black;
		}

		.calendar-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 15px;
			padding: 0 10px;
			background: black;
		}

		.nav-btn {
			background: #34495e;
			color: white;
			border: none;
			border-radius: 4px;
			width: 36px;
			height: 60px;
			font-size: 16px;
			cursor: pointer;
			transition: all 0.3s;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0; /* 防止按钮缩小 */
		}

		.nav-btn:hover {
			background: #2c3e50;
		}

		.month-year {
			font-size: 19px;
			font-weight: bold;
			color: white;
    margin: 0 15px; /* 增加左右间距 */
    text-align: center;
    flex-shrink: 1; /* 允许适当缩小 */
    min-width: 120px; /* 设置最小宽度 */
		}

		.calendar-weekdays {
			display: grid;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			grid-template-columns: repeat(7, 1fr);
			text-align: center;
			font-weight: bold;
			margin-bottom: 0px;
			color: #7f8c8d;
			padding: 0 5px;
			height: 50px;
			border-radius: 0px;
			border: 1px solid #ddd;
		}

		.weekday-sunday {
			color: #e74c3c;
			background: #fff;
		}

		.calendar-days {
			display: grid;
			grid-template-columns: repeat(7, 1fr);
		}

		.day {
			height: 60px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			border-radius: 0px;
			cursor: pointer;
			transition: all 0.2s;
			position: relative;
			font-weight: 500;
			border: 1px solid #ddd;
			background: white;
		}

		.day:hover:not(.disabled):not(.rest-day) {
			background: rgba(52, 152, 219, 0.2);
		}

		.current-day {
			background: rgba(52, 152, 219, 0.3);
			color: #2980b9;
			font-weight: bold;
		}

		.sunday.disabled {
			color: #ffcccc;
			background: #fff;
		}

		.sunday {
			color: #e74c3c;
			background: #fff;
		}

		/* 不可点击的日期 */
		.disabled {
			color: #ddd;
			background: white;
			cursor: not-allowed;
			position: relative;
		}

		/* 不可点击日期悬停时显示禁用图标 */
		.disabled:hover::after {
			content: "🚫";
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 16px;
			z-index: 10;
		}
		/* 不可点击日期悬停时显示禁用图标 */
		.disabled:hover{
			background: #f7f7f7;
		}
		/* 确保禁用图标的背景不透明 */
		.disabled:hover .day-number,
		.disabled:hover .day-week {
			visibility: hidden;
		}

		/* 休息日样式调整 */
		.rest-day {
			color: #ddd;
			background: white;
			position: relative;
			cursor: not-allowed;
		}

		.rest-day::after {
			content: "休";
			position: absolute;
			top: 3px;
			right: 3px;
			font-size: 14px;
			color: #e74c3c;
			width: 14px;
			height: 14px;
			border-radius: 50%;
			line-height: 14px;
			text-align: center;
		}

		/* 确保休息日悬停效果被禁用 */
		.rest-day:hover {
			background: #fff1f1;
			transform: none;
			box-shadow: none;
			cursor: not-allowed;
		}

		/* 确保休息日悬停时不显示禁用图标 */
		.rest-day:hover::after {
			content: "休";
		}

		.selected {
			background: rgba(52, 152, 219, 0.3);
			color: #2980b9;
			font-weight: bold;
			border: 1px solid #2980b9;
		}

		.day-number {
			font-size: 19px;
		}

		.day-week {
			font-size: 10px;
			margin-top: 2px;
			color: #7f8c8d;
		}

		.sunday .day-week {
			color: #e74c3c;
		}
        @media (max-width: 768px) {
            .calendar-header {
                flex-direction: column;
                gap: 10px;
            }
            
            .day {
                height: 36px;
                font-size: 13px;
            }
            
            .day-number {
                font-size: 12px;
            }
            
            .day-week {
                font-size: 9px;
            }
        }
        
        @media (max-width: 768px) {
.calendar-header {
        flex-direction: row; /* 保持横向排列 */
        justify-content: space-between; /* 保持两侧分布 */
        padding: 0 5px; /* 减少内边距 */
    }
    
    .nav-btn {
        width: 30px; /* 等比例缩小 */
        height: 50px; /* 等比例缩小 */
        font-size: 14px; /* 等比例缩小字体 */
    }
    
    .month-year {
        font-size: 16px; /* 等比例缩小字体 */
        margin: 0 10px; /* 调整间距 */
        min-width: 100px; /* 调整最小宽度 */
    }
            
            .day {
                height: 40px;
                font-size: 14px;
            }
        }

	@media only screen and (min-width:680px) {
		.hometop {
			width: 80%;
			margin: auto;
			margin-top: 20px;
			margin-bottom: 20px;
		}

		.title {
			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
			font-weight: bold;
			color: #000000;
		}
		.homecalend{
			width: 70%; margin: auto; margin-top: 1%; margin-bottom: 2%;
		}
	}

	@media only screen and (max-width:680px) {
		.hometop {
			width: 100%;
			margin: auto;
			margin-top: 20px;
			margin-bottom: 20px;
			padding: 0 4%;
			box-sizing: border-box;
		}

		.title {
			font-size: 28px;
			font-family: Roboto-Bold, Roboto;
			font-weight: bold;
			color: #000000;
		}
		.homecalend{
			width: 90%; margin: auto; margin-top: 1%; margin-bottom: 2%;
		}
	}
	
	@media (max-width: 480px) {
	    .nav-btn {
	        width: 25px; /* 进一步缩小 */
	        height: 40px; /* 进一步缩小 */
	        font-size: 12px; /* 进一步缩小字体 */
	    }
	    
	    .month-year {
	        font-size: 14px; /* 进一步缩小字体 */
	        margin: 0 8px; /* 调整间距 */
	        min-width: 90px; /* 调整最小宽度 */
	    }
	}
</style>
